export default __webpack_public_path__ + "static/media/Mask-Group-11-Yono@2x.f4182d25.png";